import React from "preact";

function MOTextStyleEdit() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16">
      <path fill="#333" d="M13.88 12.56H2.12a.12.12 0 00-.12.12v1.2c0 .066.054.12.12.12h11.76a.12.12 0 00.12-.12v-1.2a.12.12 0 00-.12-.12zm-9.755-1.2h1.276c.063 0 .12-.04.139-.102l.806-2.49h3.287l.799 2.49c.019.06.075.102.139.102h1.337a.144.144 0 00.146-.137.145.145 0 00-.008-.057L8.924 2.1a.149.149 0 00-.138-.1H7.252a.144.144 0 00-.138.099l-3.127 9.067a.129.129 0 00-.007.048.145.145 0 00.145.146zm3.839-7.741h.061l1.258 3.956h-2.59l1.271-3.957z"></path>
    </svg>
  );
}

export default MOTextStyleEdit;
